import { render, staticRenderFns } from "./CampaignOverview.vue?vue&type=template&id=25de32d8&scoped=true&"
import script from "./CampaignOverview.vue?vue&type=script&lang=js&"
export * from "./CampaignOverview.vue?vue&type=script&lang=js&"
import style0 from "./CampaignOverview.vue?vue&type=style&index=0&id=25de32d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25de32d8",
  null
  
)

export default component.exports